enum SCREENS {
  ONBOARDING = 'SCREEN:ONBOARDING',
  CHANGE_PROFILE_INFO = 'SCREEN:CHANGE_PROFILE_INFO',
  CHANGE_PROFILE_INFO_BUSINESS = 'SCREEN:CHANGE_PROFILE_INFO_BUSINESS',
  PASSWORD_FOR_DELETE_ACCOUNT = 'SCREEN:PASSWORD_FOR_DELETE_ACCOUNT',
  DELETE_LOADING = 'SCREEN:DELETE_LOADING',
  AUTH = 'SCREEN:AUTH',
  BOTTOM_BAR = 'SCREEN:BOTTOM_BAR',
  APP_ROOT = 'SCREEN:APP_ROOT',
  HOME_STACK = 'SCREEN:HOME_STACK',
  MY_EVENTS = 'SCREEN:MY_EVENTS',
  EVENTS_STACK = 'SCREEN:EVENTS_STACK',
  CALENDAR_STACK = 'SCREEN:CALENDAR_STACK',
  CHAT_STACK = 'SCREEN:CHAT_STACK',
  SETTINGS_STACK = 'SCREEN:SETTINGS_STACK',
  WELCOME = 'SCREEN:WELCOME',
  LOGIN = 'SCREEN:LOGIN',
  SIGN_UP = 'SCREEN:SIGN_UP',
  FORGOT_PASSWORD = 'SCREEN:FORGOT_PASSWORD',
  SET_PASSWORD = 'SCREEN:SET_PASSWORD',
  RESET_PASSWORD = 'SCREEN:RESET_PASSWORD',
  HELP_CENTER = 'SCREEN:HELP_CENTER',
  LOGOUT = 'SCREEN:LOGOUT',
  NOTIFICATIONS = 'SCREEN:NOTIFICATIONS',
  CHANGE_PASSWORD = 'SCREEN:CHANGE_PASSWORD',
  PURCHASE_HISTORY = 'SCREEN:PURCHASE_HISTORY',
  PERSONAL_INFO = 'SCREEN:PERSONAL_INFO',
  SETTINGS = 'SCREEN:SETTINGS',
  CONCIERGE_CHAT = 'SCREEN:CONCIERGE_CHAT',
  USER_CHAT = 'SCREEN:USER_CHAT',
  CHATS = 'SCREEN:CHATS',
  SINGLE_CHAT = 'SCREEN:SINGLE_CHAT',
  CHAT_INFO = 'SCREEN:CHAT_INFO',
  EVENTS = 'SCREEN:EVENTS',
  MY_EVENT = 'SCREEN:MY_EVENT',
  EDIT_EVENT = 'SCREEN:EDIT_EVENT',
  EDIT_SUBCATEGORY = 'SCREEN:EDIT_SUBCATEGORY',
  CREATE_EVENT_TEMPLATE = 'SCREEN:CREATE_EVENT_TEMPLATE',
  CREATE_EVENT_SUBCATEGORY = 'SCREEN:CREATE_EVENT_SUBCATEGORY',
  CREATE_EVENT_GROUPS = 'SCREEN:CREATE_EVENT_GROUPS',
  CREATE_EVENT_INFO = 'SCREEN:CREATE_EVENT_INFO',
  LOGISTIC_OPTION = 'SCREEN:LOGISTIC_OPTION',
  CREATE_EVENT_SUBMITTING = 'SCREEN:CREATE_EVENT_SUBMITTING',
  CALENDAR = 'SCREEN:CALENDAR',
  CALENDAR_CHANGE_DATE = 'SCREEN:CALENDAR_CHANGE_DATE',
  CALENDAR_EVENT = 'SCREEN:CALENDAR_EVENT',
  HOME = 'SCREEN:HOME',
  HOME_EVENT = 'SCREEN:HOME_EVENT',
  BUY_TICKET = 'SCREEN:BUY_TICKET',
  RATE_EVENT = 'SCREEN:RATE_EVENT',
  PAYMENT_SUCCESS = 'SCREEN:PAYMENT_SUCCESS',
  MAP = 'SCREEN:MAP',
  ONBOARDING_ACCOUNT_TYPE = 'SCREEN:ONBOARDING_ACCOUNT_TYPE',
  ONBOARDING_GROUP = 'SCREEN:ONBOARDING_GROUP',
  ONBOARDING_CHILDREN = 'SCREEN:ONBOARDING_CHILDREN',
  ONBOARDING_PERSONAL_INFO = 'SCREEN:ONBOARDING_PERSONAL_INFO',
  ONBOARDING_CATEGORIES = 'SCREEN:ONBOARDING_CATEGORIES',
  ONBOARDING_SUBCATEGORIES = 'SCREEN:ONBOARDING_SUBCATEGORIES',
  ONBOARDING_BUSINESS_INFO = 'SCREEN:ONBOARDING_BUSINESS_INFO',
  LOADING = 'SCREEN:LOADING',
  UPDATE_APP = 'SCREEN:UPDATE_APP',
  PENDING_ATTENDEES = 'SCREEN:PENDING_ATTENDEES',
  MATCHING_USERS = 'SCREEN:MATCHING_USERS',
  EDIT_SUBCATEGORIES = 'SCREENS:EDIT_SUBCATEGORIES',
  EDIT_PREFERANCE = 'SCREENS:EDIT_PREFERANCE',
  GROUPS = 'SCREEN:GROUPS',
  MODERN_SPLASH = 'SCREEN:MODERN_SPLASH',
  MAGICAL_SPLASH = 'SCREEN:MAGICAL_SPLASH',
  MODERN_INTRO = 'SCREEN:MODERN_INTRO',
  MODERN_AUTH = 'SCREEN:MODERN_AUTH',
  OTP_VERIFICATION = 'SCREEN:OTP_VERIFICATION',
  PYXI_SELECT_QUIZ = 'SCREEN:PYXI_SELECT_QUIZ',
  SUBSCRIPTIONS = 'SCREEN:SUBSCRIPTIONS',
}

export default SCREENS;
